<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><span aria-label=" page 17. " epub:type="pagebreak" id="page_17" role="doc-pagebreak"><img alt="image" class="imagefp" src="e9781416503712/images/f0017-01.jpg"/></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01a.vue?3bd28d8c